import React from 'react'
import './services.css'
export default function services() {
  return (
    <div className='services'>
    <br></br>
      <h1>Our Services</h1>
      <p>At Samraj Solar Energies, we provide end-to-end solar solutions to help you transition seamlessly to sustainable energy. Our holistic approach ensures optimal performance, quality, and reliability. Here’s an overview of our key services:</p>

      {/*c1*/}
     <div className='c1'>
        {/*computer*/}
        <div className='leftlpcontent'>
            <h2>1.Site Survey</h2>
            <p>A successful solar project begins with a comprehensive site survey. Our team conducts a detailed analysis, assessing factors like sunlight exposure, shading, roof inclination, and structural integrity.</p>
            <p>Through advanced tools and techniques, we determine the ideal placement and system size, ensuring maximum energy yield tailored to your property.</p>
            <br></br>
        </div>
        {/*computer*/}
        <div className='rightlaptop'>
            <img className='image'src='./img6.jpg' alt=''/>
        </div>
        {/*mobile*/}
        <div className='leftmob'>
            <img className='image' src='./img6.jpg' alt=''/>
        </div>
     </div>
      

      {/*c2*/}
      <div className='c2'>
        {/*computer*/}
         <div className='leftlaptop'>
            <img className='image'src='./img7.jpg' alt=''/>
        </div> 

        <div className='rightlpcontent'>
            <h2>2. Design & Engineering</h2>
            <p>A successful solar project begins with a comprehensive site survey. Our team conducts a detailed analysis, assessing factors like sunlight exposure, shading, roof inclination, and structural integrity.</p>
            <p>Through advanced tools and techniques, we determine the ideal placement and system size, ensuring maximum energy yield tailored to your property.</p>
        </div>

        {/*mobile*/}
        <div className='rightmob'>
            <img  className='image' src='./img7.jpg' alt=''/>
        </div>
     </div>



      {/*point3*/}
     <div className='c1'>
        {/*computer*/}
        <div className='leftlpcontent'>
        <h2>3.Supply of Equipment</h2>
        <p>Samraj Solar Energies partners with industry-leading manufacturers to supply high-quality, durable equipment including panels, inverters, and mounting structures.</p>
        <p>We ensure that all components meet stringent standards, which guarantees both high efficiency and long-term reliability.</p>
        <br></br>
        </div>
        {/*computer*/}
        <div className='rightlaptop'>
            <img className='image'src='./img8.jpg' alt=''/>
        </div>

        {/*mobile*/}
        <div className='leftmob'>
            <img className='image' src='./img8.jpg' alt=''/>
        </div>
     </div> 


      {/*point4*/}
       <div className='c2'>
        {/*computer*/}
         <div className='leftlaptop'>
            <img className='image'src='./img9.jpg' alt=''/>
        </div> 

        <div className='rightlpcontent'>
        <h2>4.Installation and Commissioning</h2>
        <p>Our certified technicians handle the entire installation process meticulously, from setting up mounts to wiring and testing. We ensure all installations comply with local and national safety standards.</p>
        <p>Post-installation, we rigorously test the system and commission it to guarantee optimal functionality from day one.</p>
        </div>

        {/*mobile*/}
        <div className='rightmob'>
            <img className='image' src='./img9.jpg' alt=''/>
        </div>
     </div>

      

      

      {/*point5*/}


      <div className='c1'>
        
        {/*computer*/}
        <div className='leftlpcontent'>
        <h2>5.Remote Monitoring</h2>
        <p>Our remote monitoring services give you full visibility over your system’s performance in real-time. With our state-of-the-art software, you can track energy production, consumption, and efficiency remotely.</p>
        <p>In case of irregularities or performance drops, our system sends instant alerts, enabling our team to take corrective actions immediately.</p>
        <br></br>
        </div>
        {/*computer*/}
        <div className='rightlaptop'>
            <img className='image'src='./img3.jpeg' alt=''/>
        </div>

        {/*mobile*/}
        <div className='leftmob'>
            <img  className='image' src='./img3.jpeg' alt=''/>
        </div>
     </div>
    <br></br>
    </div>
  )
}
